var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "onboarding-steps" }, [
    _c(
      "button",
      {
        staticClass: "onboarding-abandon-btn",
        attrs: { title: _vm.$t("onboarding.common.abandon") },
        on: { click: _vm.handleAbandon },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    ),
    _c(
      "div",
      {
        staticClass: "step",
        class: {
          active: _vm.currentStep === "networks",
          completed: _vm.isStepCompleted("networks"),
        },
        on: {
          click: function ($event) {
            return _vm.navigateToStep("networks")
          },
        },
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "step-content" }, [
          _c("div", { staticClass: "step-title" }, [
            _vm._v(_vm._s(_vm.$t("onboarding.steps.networks_title"))),
          ]),
          _c("div", { staticClass: "step-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("onboarding.steps.networks_subtitle"))),
          ]),
        ]),
      ]
    ),
    _c("span", { staticClass: "step-breadcrumb" }),
    _c(
      "div",
      {
        staticClass: "step",
        class: {
          active: _vm.currentStep === "features",
          completed: _vm.isStepCompleted("features"),
        },
        on: {
          click: function ($event) {
            return _vm.navigateToStep("features")
          },
        },
      },
      [
        _vm._m(1),
        _c("div", { staticClass: "step-content" }, [
          _c("div", { staticClass: "step-title" }, [
            _vm._v(_vm._s(_vm.$t("onboarding.steps.features_title"))),
          ]),
          _c("div", { staticClass: "step-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("onboarding.steps.features_subtitle"))),
          ]),
        ]),
      ]
    ),
    _c("span", { staticClass: "step-breadcrumb" }),
    _c(
      "div",
      {
        staticClass: "step",
        class: {
          active: _vm.currentStep === "pages",
          completed: _vm.isStepCompleted("pages"),
          error: _vm.isPageLimitReached,
        },
      },
      [
        _vm._m(2),
        _c("div", { staticClass: "step-content" }, [
          _c("div", { staticClass: "step-title" }, [
            _vm._v(_vm._s(_vm.$t("onboarding.steps.pages_title"))),
          ]),
          _c("div", { staticClass: "step-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("onboarding.steps.pages_subtitle", {
                    count: _vm.totalSelectedPages,
                    max: _vm.userPlanPageQuota,
                  })
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm.isPageLimitReached
          ? _c("div", { staticClass: "step-badge" }, [
              _c(
                "span",
                {
                  staticClass: "badge-alert",
                  attrs: {
                    "data-tooltip": _vm.$t(
                      "onboarding.steps.pages_quota_reached"
                    ),
                  },
                },
                [_vm._v("●")]
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm.selectedNetworks.length > 0
      ? _c(
          "div",
          { staticClass: "step-children" },
          _vm._l(_vm.selectedNetworks, function (network) {
            return _c(
              "div",
              {
                key: network,
                staticClass: "step-child",
                class: {
                  active:
                    _vm.currentStep === "pages" &&
                    _vm.currentNetwork === network,
                },
                on: {
                  click: function ($event) {
                    return _vm.navigateToNetwork(network)
                  },
                },
              },
              [
                _c("div", { staticClass: "step-icon" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.getNetworkIcon(network),
                      alt: _vm.getNetworkName(network),
                    },
                  }),
                ]),
                _c("div", { staticClass: "step-content" }, [
                  _c("div", { staticClass: "step-title" }, [
                    _vm._v(_vm._s(_vm.getNetworkName(network))),
                  ]),
                ]),
                _vm.getConnectedCount(network) > 0
                  ? _c("div", { staticClass: "step-badge" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.getConnectedCount(network)) +
                          "\n    "
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "step",
        class: {
          active: _vm.currentStep === "summary",
          completed: _vm.isStepCompleted("summary"),
        },
        on: {
          click: function ($event) {
            return _vm.navigateToStep("summary")
          },
        },
      },
      [
        _vm._m(3),
        _c("div", { staticClass: "step-content" }, [
          _c("div", { staticClass: "step-title" }, [
            _vm._v(_vm._s(_vm.$t("onboarding.steps.summary_title"))),
          ]),
          _c("div", { staticClass: "step-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("onboarding.steps.summary_subtitle"))),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-icon" }, [
      _c("img", {
        attrs: {
          src: require("@/components/onboarding/assets/icons/network-icon.svg"),
          alt: "Réseaux",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-icon" }, [
      _c("img", {
        attrs: {
          src: require("@/components/onboarding/assets/icons/features-icon.svg"),
          alt: "Fonctionnalités",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-icon" }, [
      _c("img", {
        attrs: {
          src: require("@/components/onboarding/assets/icons/logout-icon.svg"),
          alt: "Pages",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-icon" }, [
      _c("img", {
        attrs: {
          src: require("@/components/onboarding/assets/icons/post-icon.svg"),
          alt: "Résumé",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }